import { actionTypes } from "./constants";
const treePrefix = {
  PRODUCT: "PRODUCT",
  CATEGORY: "CATEGORY",
  SUB_CATEGORY: "SUB_CATEGORY",
  SOLUTION: "SOLUTION",
};

const treType = {
  按产品: "CATEGORY",
  按解决方案: "SOLUTION",
};

const initialState = {
  docList: {
    rows: [],
    count: 0,
  },
  docTypeList: [],
  docCenterTree: {},
  docCenterTreeFormat: [],
  docCenterList: {
    rows: [],
    count: 0,
  },
};

const productFormat = (productList, type) => {
  const format = (productList, pid) => {
    const formatList = [];
    productList.forEach((_p) => {
      const { products, categorySubs } = _p;
      const formatProducts = (products || []).map((product) => ({
        ...product,
        type: treePrefix.PRODUCT,
      }));
      const formatCategorySubs = (categorySubs || []).map((categorySub) => ({
        ...categorySub,
        type: treePrefix.SUB_CATEGORY,
      }));
      if (products || categorySubs) {
        const obj = {
          key: `${treePrefix[_p.type || type]}-${_p.id}`,
          id: _p.id,
          title: _p.title,
          type: _p.type || treePrefix.CATEGORY,
          children: format([...formatProducts, ...formatCategorySubs], _p.id),
        };
        formatList.push(obj);
        return;
      }
      formatList.push({
        key: `${treePrefix[type]}-${pid}-${treePrefix.PRODUCT}-${_p.id}`,
        id: _p.id,
        title: _p.model,
        productTitle: _p.title,
        type: _p.type || treePrefix.PRODUCT,
      });
    });
    return formatList;
  };
  return format(productList, 0);
};

const formatDocCenterTree = (data) => {
  const formatTree = [];
  Object.keys(data).forEach((key) => {
    formatTree.push({
      key: key,
      title: key,
      children: productFormat(data[key], treType[key]),
    });
  });

  return formatTree;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_DOC_LIST:
      return {
        ...state,
        docList: action.data,
      };
    case actionTypes.SET_DOC_TYPE_LIST:
      return {
        ...state,
        docTypeList: action.data,
      };
    case actionTypes.SET_DOC_CENTER_TREE:
      return {
        ...state,
        docCenterTree: action.data,
        docCenterTreeFormat: formatDocCenterTree(action.data),
      };
    case actionTypes.SET_DOC_CENTER_LIST:
      return {
        ...state,
        docCenterList: action.data,
      };
    default:
      return state;
  }
}
